import { connect } from 'react-redux'

import { useI18n } from 'locales'
import { calendarAccountsSelector } from 'selectors'
import { currentUserSelector } from 'selectors/user'

import { CalendarsLine as Container } from './styles'

const CalendarsString = ({ calendarAccounts, locale }) => {
  const { i18n } = useI18n()

  if (!calendarAccounts?.length) {
    return i18n.t('publisher.mutual_availability.header.internal', { locale })
  }

  const title = calendarAccounts[0].kind === 'outlook_desktop'
    ? i18n.t('publisher.calendar.outlook_desktop.title', { locale })
    : calendarAccounts[0].email

  if (calendarAccounts.length === 1) return title

  return i18n.t(
    'publisher.mutual_availability.header.external',
    {
      title,
      count: calendarAccounts.length - 1,
      locale
    }
  )
}

const CalendarsLine = ({ calendarAccounts, locale }) => (
  <Container>
    <CalendarsString calendarAccounts={calendarAccounts} locale={locale} />
  </Container>
)

const mapStateToProps = (state) => {
  const currentUser = currentUserSelector(state)

  return {
    calendarAccounts: calendarAccountsSelector(state),
    locale: currentUser.locale
  }
}

export default connect(mapStateToProps)(CalendarsLine)
